<template lang="pug">
    include ../helpers/pug/mixins
    .rsl-loader(v-bind:style='loader')
        div(
            v-bind:class='[iconClass, `rsl-loader__${viewType}`]'
            v-bind:style='loaderStyles'
        )

</template>

<script>
export default {
    props: {
        /**
             * Тип иконки прелоадера, которая будет отображаться на странице, по умолчанию это 'book'
             * @type {String}
             */
        viewType: {
            type: String,
            required: false,
            default: 'book'
        },
        /**
             * Флаг который утверждает центровать прелоадер или нет.
             * @type {Boolean}
             */
        centered: {
            type: Boolean,
            required: false,
            default: false
        },
        /**
             * Класс который биндится на прелоадер, в него нужно передать обязательно свойство
             * background-image с медиа-выражением для ретинизации
             * @type {String}
             */
        iconClass: {
            type: String,
            required: true,
            default: 'preloader-icon__thumb'
        }
    },
    computed: {
        loader() {
            return {
                margin: this.centered ? '0 auto' : 'initial',
                width: this.loaderStyles.width,
                height: this.loaderStyles.height
            };
        },
        loaderStyles() {
            if (this.viewType === 'book') {
                return {
                    width: '80px',
                    height: '44px'
                };
            }

            if (this.viewType === 'thumb') {
                return {
                    width: '17px',
                    height: '17px'
                };
            }
            return false;
        }
    }
};
</script>

<style lang="sass" src="./rsl-loader.sass"></style>
